import { ReactNode, useState, useEffect } from 'react';
import { UserRejectedRequestError } from '@web3-react/injected-connector';
import { UserRejectedRequestError as WalletConnectUserRejectError } from '@web3-react/walletconnect-connector';

import useModalState from '../modal/useModalState';
import ErrorContext from './errorContext';
import useToastState from '../toast/useToastState';

type Props = {
    children: ReactNode;
};

const requestRejectedErrMsg = (message: string) => {
    switch (true) {
        case message === 'MetaMask Message Signature: User denied message signature.':
        case message ===
            'MetaMask Typed Message Signature: User denied message signature.':
            return 'Message Signature Rejected';
        case message === 'MetaMask Tx Signature: User denied transaction signature.':
        case message.includes('user rejected transaction'):
            return 'Transaction Rejected';
        default:
            return 'Request Rejected';
    }
};

const ErrorState: React.FC<Props> = ({ children }) => {
    const { openModal, setModalData } = useModalState();

    const { setToast } = useToastState();

    const [error, setError] = useState<any>(null);

    useEffect(() => {
        if (!error) return;

        switch (true) {
            case error instanceof UserRejectedRequestError:
            case error instanceof WalletConnectUserRejectError:
            case error?.code === 4001:
            case error?.code === -32603:
            case error.code === 'ACTION_REJECTED':
                setToast(
                    {
                        type: 'danger',
                        message: requestRejectedErrMsg(error.message),
                    },
                    requestRejectedErrMsg(error.message)
                );
                return;
            default:
                const message = 'Unexpected error. Please try again later';

                setToast(
                    {
                        type: 'danger',
                        message,
                    },
                    message
                );
                console.log(error);
        }

        // reset error state
        setError(null);
    }, [error, openModal, setModalData, setToast]);

    return (
        <ErrorContext.Provider value={{ error, setError }}>
            {children}
        </ErrorContext.Provider>
    );
};
export default ErrorState;
